import { createSelector } from 'reselect'

import { selectCommitmentState } from './selectCommitmentState'

export const selectCommitmentItems = createSelector(
  [selectCommitmentState],
  (state) => state.commitmentItems.data
)
